import { createUseThemeHook } from 'legos/theme';

// Augment the global BulkLegoTheme interface to support our lego theme
declare module 'legos/theme' {
  interface BulkLegoTheme {
    radio: RadioTheme;
  }
}

export interface RadioTheme {
  disabledColor: string;
  color: string;
  borderColor: string;
  errorColor: string;
  disabledLabelColor: string;
  selectedFocusedColor: string;
  unselectedFocusedColor: string;
}

const [RadioThemeProvider, useRadioTheme] = createUseThemeHook(
  'radio',
  (global): RadioTheme => ({
    // Create defaults for your theme from the global lego theme color palette
    disabledColor: global.neutral.color300,
    color: global.positive.color500,
    borderColor: global.neutral.color600,
    errorColor: global.negative.color500,
    disabledLabelColor: global.neutral.color700,
    selectedFocusedColor: global.neutral.color100,
    unselectedFocusedColor: global.neutral.color100
  })
);

export { RadioThemeProvider, useRadioTheme };
